import styled from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';
import { chatKeyboardFocusVisible } from '../../styles/chatFocus';

export const Container = styled.div`
  gap: 16px;
  width: 100%;
`;

export const PropertyBlock = styled.div`
  gap: 8px;
  width: 100%;
  padding-bottom: 8px;

  .m-integrated-imagery-view-details button {
    ${chatKeyboardFocusVisible}
  }
`;

export const PropertyNameButton = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  ${chatKeyboardFocusVisible}
`;

// WIP - This is a temporary style for the favorite save button wrapper.
export const FavoriteSaveButtonWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  /* Override SaveHotelButton default absolute overlay style for inline chat layout */
  & > div {
    position: static;
  }

  & .icon-container {
    position: static !important;
    right: auto !important;
    top: auto !important;
    width: auto !important;
    min-width: 32px;
    height: 32px !important;
    padding: 8px 12px;
    border: 1px solid #eee;
    border-radius: 999px !important;
    background: #fff !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.07);
    gap: 4px;
    transition: box-shadow 0.2s ease;

    &:hover {
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
    }

    &:focus {
      outline: none;
    }

    /* Pill uses a light #eee border; hide it when focused or it stacks with the focus ring */
    &:focus-visible {
      outline: -webkit-focus-ring-color auto 1px;
      border-color: transparent;
    }
  }

  & .save-hotel-visible-label {
    font-size: 13px;
    font-weight: 500;
    line-height: 1;
    color: #1c1c1c;
  }

  & .icon-container .icon-inverse {
    color: #1c1c1c !important;
  }

  /* Icon font glyphs render from pseudo-elements in this stack */
  & .icon-container .icon-heart-outline::before,
  & .icon-container .icon-heart-fill::before {
    color: #1c1c1c !important;
    -webkit-text-fill-color: #1c1c1c !important;
    opacity: 1 !important;
  }
`;

export const RatingsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0 4px;
  font-size: 12px;
  line-height: 1.5;
  color: var(--color-set-brand-alt-color, #707070) !important;
  width: 100%;
`;

export const PriceSectionWrapper = styled.div`
  width: 100%;
`;

export const ImagesRow = styled.div`
  box-sizing: border-box;

  /* Mobile/Tablet: extend carousel width into parent's left padding for edge-to-edge scroll */
  /* Note: margin-left is handled via global class (ml-n4 ml-lg-0) in JSX */
  width: calc(100% + 24px);

  /* Desktop (992px+): reset to normal width when sidebar is visible */
  @media ${baseVariables.mediaQuery.lg} {
    width: 100%;
  }
`;
